export default {
    name: 'marking--nkMapping',
    apiService: 'shoes',
    apiPath: '/admin/nk_mapping',
  };
  